import React from 'react'
import LeftBar from '../../Components/LeftBar' 
import Dashnav from '../../Components/Dashnav'
import BillsComp from './BillsComp'

function Bills() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <BillsComp/>      
        </div>
    </div>
  )
}

export default Bills